<template>
    <div class="bjex-main" v-loading="loading">
        <el-page-header @back="goBack"> </el-page-header>
        <div style="    padding: 10px 0;font-weight: bold;    font-size: 16px;">{{ ruleForm.resTitle }}</div>
        <div style="    padding: 10px 0;">
            <el-tag>{{ruleForm.resTypeTitle}}</el-tag>
            <el-tag type="warning">{{ruleForm.resStepTitle}}</el-tag>
            <el-tag type="danger">{{ruleForm.resSourceTitle}}</el-tag>
        </div>
        <el-tabs v-model="activeName" >
            <el-tab-pane label="资源介绍" name="1">
                <div v-html="ruleForm.resContent"></div>
            </el-tab-pane>
            <el-tab-pane label="资源附件" name="2">
                <div @click="yulan(item)" v-for="(item,index) in ruleForm.resourceList" :key="index" style="background: rgb(246, 246, 246);padding: 10px ;line-height: 30px;    margin-bottom: 15px;cursor: pointer;">
                     <div>{{ item.fileName }}</div>
                     <div style="color: #666;">{{ item.updateTime }}</div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import * as homeApi from '@/api/home'
import { ERR_OK, BASE_URL } from '@/api/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
const editorConfig = {
    // JS 语法
    MENU_CONF: {
        uploadImage: {
            server: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
            customInsert(res, insertFn) {
                // JS 语法
                // res 即服务端的返回结果
                let url = res.data[0].url
                let alt = ''
                let href = res.data[0].url
                // 从 res 中找到 url alt href ，然后插入图片
                insertFn(url, alt, href)
            }
        },
        uploadVideo: {
            server: BASE_URL + '/evaluate//file/oss-upload', //上传图片地址
            customInsert(res, insertFn) {
                // JS 语法
                // res 即服务端的返回结果
                let url = res.data[0].url
                let poster = ''
                // 从 res 中找到 url alt href ，然后插入图片
                insertFn(url, poster)
            }
        }
    }

    // 其他属性...
}
export default {
    data() {
        return {
            ossDialog: false,
            prefix: "",
            activeName:'1',
            ossUrl: ["read/"],
            videoOssList: [],
            marker: "",
            nextMarker: "",
            videoDisabled: false,
            pageArr: [],
            headers: {
                token: "" //文件上传请求头
            },
            xuelist: [
                { name: '老师使用', id: 0 },
                { name: '学生使用', id: 1 }
            ],
            upload: BASE_URL + "/evaluate//file/oss-upload",
            loading: false,
            datas: {
                bucketId: 2
            },
            editorConfig: editorConfig,
            mode: 'default', // or 'simple'
            toolbarConfig: {
                excludeKeys: ['group-video']
            },
            curPage: 1,
            editor1: null,
            ruleForm: {
                resId: '',
                resTitle: '',
                resTypeIds: [],
                resStepIds: [],
                resSourceId: '',
                resourceList: [],
                resSort: 0,
                resSourceTitle: '',
                resStepTitle: '',
                resTypeTitle: '',
                resContent: '',
                userType: [],
            },
            rules: {
                resTitle: [
                    { required: true, message: '请输入活动名称', trigger: 'blur' },
                    { max: 50, message: '长度最多50个字符', trigger: 'blur' }
                ],
                userType: [
                    { required: true, message: '请选择使用对象', trigger: 'blur' },
                ],
                resourceList: [
                    { required: true, message: '请选择或者上传资源文件', trigger: 'blur' },
                ],
                resStepIds: [
                    { required: true, message: '请选择资源阶段', trigger: 'blur' },
                ],
                resSourceId: [
                    { required: true, message: '请选择资源来源', trigger: 'blur' },
                ],
                resTypeIds: [
                    { required: true, message: '请选择资源类型', trigger: 'blur' },
                ],
            },
            headers: {
                token: '' //文件上传请求头
            },
            resource_typelist: [],
            resource_originlist: [],
            resource_steplist: [],
            bookLevelList: [],
            classinfo: []
        }
    },
    created() {
        this.headers.token = localStorage.getItem("token");
        if (this.$route.query.resId) {
            this.resourcegetInfo()
        }
        this.dictcode()
        this.dictcode1()
        this.dictcode2()
        this.dictcode3()
    },
    components: {
        Editor,
        Toolbar
    },
    watch: {

    },
    methods: {
        yulan(s){
            this.$router.push({
                path: '/pdf',
                query: {
                    url:this.ruleForm.serverHttp+s.fileUrl
                }
            })
        },  
        handlePreview(file) {
            // let url =
            //     "http://bk.welaiedu.cn/#/prepare_pdf?id=" +
            //     file.resId +
            //     "&token=" +
            //     localStorage.getItem("token");
            // window.open(url, "_blank");
            // localStorage.setItem('bookId','')
            // localStorage.setItem('fileUrl', this.ruleForm.serverHttp + file.fileUrl)
            // this.$emit('navlink', 'read_pre_view')
        },
        resourcegetInfo() {
            let that = this
            let params = {
                // bucketType: "live",
                resId:this.$route.query.resId,
            };
            homeApi.resourcegetInfo(params).then((res) => {
                if (res.data.code == 0) {
                    res.data.data.resStepIds = res.data.data.resStepIds.split(",")
                    res.data.data.resTypeIds = res.data.data.resTypeIds.split(",")
                    res.data.data.userType = res.data.data.userType.split(",")
                    for (var i = 0; i < res.data.data.resStepIds.length; i++) {
                        res.data.data.resStepIds[i] = parseInt(res.data.data.resStepIds[i])
                    }
                    for (var i = 0; i < res.data.data.resTypeIds.length; i++) {
                        res.data.data.resTypeIds[i] = parseInt(res.data.data.resTypeIds[i])
                    }
                    for (var i = 0; i < res.data.data.userType.length; i++) {
                        res.data.data.userType[i] = parseInt(res.data.data.userType[i])
                    }
                    for (var i = 0; i < res.data.data.resourceList.length; i++) {
                        res.data.data.resourceList[i].name = res.data.data.resourceList[i].fileName
                    }
                    this.ruleForm = res.data.data
                    console.log(this.ruleForm)
                }
            });
        },
        yuanh(vul) {
            let name = true
            for (var i = 0; i < this.classinfo.length; i++) {
                if (vul.name == this.classinfo[i].name) {
                    name = false
                }
            }
            return name
        },
        selectvideo(info) {
            info.name = info.name
            info.fileName = info.path
            info.fileUrl = info.fileName
            info.fileSize = info.size
            this.classinfo.push(info)
            console.log(this.classinfo)
            // this.ossDialog = false;
        },
        topUrl(url) {
            let idx = this.ossUrl.indexOf(url) + 1;
            if (!!this.ossUrl[idx]) {
                this.ossUrl.splice(idx, this.ossUrl.length);
                this.pageArr = [];
                this.queryVideoList();
            }
        },
        queryOss() {
            console.log(this.ossUrl);
            this.pageArr = [];
            this.queryVideoList(-1);
        },
        ossSelect() {
            this.queryVideoList();
            this.ossDialog = true;
        },
        // 单行双击
        rowClick(row) {
            let idx = row.name.indexOf(this.prefix);
            if (idx == -1) {
                this.ossUrl.push(this.prefix + row.name);
            } else {
                this.ossUrl.push(row.name);
            }
            this.prefix = "";
            this.pageArr = [];
            this.queryVideoList();
        },
        // 获取视频目录
        queryVideoList(state) {
            let url = "";
            this.ossUrl.forEach((item) => {
                url = url + item;
            });
            if (state == -1) {
                url = url + this.prefix;
            }
            let params = {
                // bucketType: "live",
                prefix: url,
                curPage: this.curPage,
                pageSize: 10,
            };
            let len = this.pageArr.length;
            if (state == "nextMarker") {
                params.marker = this.nextMarker;
                this.pageArr.push(this.nextMarker);
            }
            if (state == "marker") {
                if (len == 1) {
                    params.marker = null;
                } else {
                    params.marker = this.pageArr[len - 2];
                }
                this.pageArr.splice(len - 1, 1);
            }
            homeApi.queryVideoList(params).then((res) => {
                if (res.data.code == 0) {
                    this.videoOssList = res.data.data.objectList;
                    this.marker = res.data.data.marker;
                    this.nextMarker = res.data.data.nextMarker;
                }
            });
        },
        handleAvatarSuccess(res, file) {
            res.data[0].name = res.data[0].originalFilename
            res.data[0].fileName = res.data[0].originalFilename
            res.data[0].fileUrl = res.data[0].fileName
            res.data[0].fileSize = res.data[0].size
            this.ruleForm.resourceList.push(res.data[0])
        },
        handleRemove(res, file) {
            this.ruleForm.resourceList = file
        },
        onCreated1(editor) {
            this.editor1 = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        goBack() {
            history.go(-1);
        },
        removeDuplicates(array) {
            return [...new Set(array)];
        },
        submitForm(formName) {
            let that = this
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.resourceList = this.ruleForm.resourceList.concat(this.classinfo);
                    this.ruleForm.resourceList = this.removeDuplicates(this.ruleForm.resourceList);
                    this.ruleForm.resTypeTitle = ''
                    for (var i = 0; i < that.resource_typelist.length; i++) {
                        for (var s = 0; s < this.ruleForm.resTypeIds.length; s++) {
                            if (that.resource_typelist[i].id == this.ruleForm.resTypeIds[s]) {
                                this.ruleForm.resTypeTitle += that.resource_typelist[i].name + ','
                            }
                        }
                    }
                    this.ruleForm.resStepTitle = ''
                    for (var i = 0; i < that.resource_steplist.length; i++) {
                        for (var s = 0; s < this.ruleForm.resStepIds.length; s++) {
                            if (that.resource_steplist[i].id == this.ruleForm.resStepIds[s]) {
                                this.ruleForm.resStepTitle += that.resource_steplist[i].name + ','
                            }
                        }
                    }
                    this.ruleForm.resSourceTitle = ''
                    for (var i = 0; i < that.resource_originlist.length; i++) {
                        if (that.resource_originlist[i].id == this.ruleForm.resSourceId) {
                            this.ruleForm.resSourceTitle = that.resource_originlist[i].name
                        }
                    }
                    let params = {
                        resId: this.ruleForm.resId,
                        resTitle: this.ruleForm.resTitle,
                        resTypeIds: this.ruleForm.resTypeIds.toString(),
                        resStepIds: this.ruleForm.resStepIds.toString(),
                        resSourceId: this.ruleForm.resSourceId.toString(),
                        resourceList: this.ruleForm.resourceList,
                        resSort: this.ruleForm.resSort,
                        resSourceTitle: this.ruleForm.resSourceTitle,
                        resStepTitle: this.ruleForm.resStepTitle,
                        resTypeTitle: this.ruleForm.resTypeTitle,
                        resContent: this.ruleForm.resContent,
                        userType: this.ruleForm.userType.toString(),
                        bookId:localStorage.getItem('bookId')
                    }
                    homeApi
                        .resourcesave(params)
                        .then((res) => {
                            that.$message({
                                type: 'success',
                                message: '保存成功!'
                            })
                            history.go(-1);
                            // if(localStorage.getItem('bookId')==''){
                            //     this.$emit('navlink', 'read_resources')
                            // }else{
                            //     this.$emit('navlink', 'read_newly')
                            // }
                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            history.go(-1);
        },
        dictcode() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_type'
                })
                .then((res) => {
                    that.resource_typelist = res.data.data
                })
        },
        dictcode1() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_origin'
                })
                .then((res) => {
                    that.resource_originlist = res.data.data
                })
        },
        dictcode2() {
            let that = this
            homeApi
                .dictcode({
                    code: 'resource_step'
                })
                .then((res) => {
                    that.resource_steplist = res.data.data
                })
        },
        dictcode3() {
            let that = this
            homeApi
                .dictcode({
                    code: 'school_feature'
                })
                .then((res) => {
                    that.bookLevelList = res.data.data
                })
        },
    }
}
</script>

<style lang="less" scoped></style>


// WEBPACK FOOTER //
// src/components/read/details.vue